<script setup>
const props = defineProps({
    to: {
        type: String,
        required: true
    }
});
</script>

<template>
    <Button link
            @click="$router.push(to)"
            class="!text-white hover:underline !text-lg"
    >
        <slot />
    </Button>
</template>
